const localStorage = window.localStorage;

export const TwitterResponseTypes = {
  CONNECT: 'connect',
  AUTH: 'auth',
  ERROR: 'error',
  STATUS: 'status',
  TWEET: 'tweet'
};

export default class TwitterApi {
  constructor(socket, apiUrl, callback) {
    this.lsKey = 'luci_tw_user';

    this.callback = callback;
    this.apiUrl = apiUrl;
    this.popup = null;
    this.socket = socket;
    this.clientId = null;
    this.user = this.getLocalStorageUser();

    this.initWebSocket();
  }

  /**
   * Sends response to callback.
   */
  sendResponse = response => {
    if (this.callback) {
      this.callback(response);
    }
  };

  /**
   * Gets necessary headers for api calls.
   */
  getHeader = () => {
    const headers = {
      'Content-Type': 'application/json'
    };

    if (this.user) {
      headers.Authorization = `OAuth oauth_token="${this.user.accessToken}" oauth_token_secret="${
        this.user.accessTokenSecret
      }"`;
      headers.TwUserId = this.user.id;
    }

    if (this.clientId) {
      headers.ClientId = this.clientId;
    }

    return headers;
  };

  isAuthenticated = () => !!this.user;

  /**
   * Gets the user from local store
   */
  getLocalStorageUser = () => {
    const user = getLocalStorageObject(this.lsKey);

    if (user) {
      this.sendResponse({
        type: TwitterResponseTypes.AUTH,
        data: user
      });
    }

    return user;
  };

  /**
   * Initializes the socketio listeners.
   */
  initWebSocket = () => {
    if (!this.socket) {
      return;
    }
    this.socket.on('connected', clientId => {
      this.clientId = clientId;
    });
    this.socket.on('disconnected', () => {
      this.clientId = null;
    });
    this.socket.on('twitter', message => {
      console.log('Received message from smapi');

      switch (message.type) {
        case TwitterResponseTypes.CONNECT:
          this.clientId = message.data.id;
          break;
        case TwitterResponseTypes.AUTH:
          console.log('Received auth from twitter api');
          if (message.data.accessToken) {
            this.user = {
              id: message.data.id,
              name: message.data.name,
              screenName: message.data.screenName,
              accessToken: message.data.accessToken,
              accessTokenSecret: message.data.accessTokenSecret
            };
            setLocalStorageObject(this.lsKey, this.user);
            if (this.sendResponse) {
              this.sendResponse(message);
            }
          }
          if (this.popup) {
            this.popup.close();
            this.popup = null;
          }
          break;
        case TwitterResponseTypes.TWEET:
          this.sendResponse(message);
          break;
        default:
          break;
      }
    });
  };

  /**
   * Spawns the login dialog
   */
  loginDialog = forceLogin =>
    new Promise((resolve, reject) => {
      if (!this.clientId) {
        return reject('Not connected to social media api service');
      }
      this.popup = window.open(
        `${this.apiUrl}/api/twitter/auth/id/${this.clientId}${
          forceLogin ? '?forceLogin=true' : ''
        }`,
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600}'
      );
      resolve();
    });

  /**
   * Locally logs out the user by removing from store.
   */
  logout = () => {
    this.user = null;
    setLocalStorageObject(this.lsKey);
    this.sendResponse({ type: TwitterResponseTypes.AUTH });
  };

  /**
   * Post a tweet
   */
  tweet = (status, filePath) =>
    new Promise((resolve, reject) => {
      if (!this.user) {
        return reject('No access token detected.  Authenticate and then try again.');
      }

      if (!status && !filePath) {
        return reject('status or filePath is required');
      }

      if (status.length > 280) {
        return reject('Status exceeds the 280 character limit of Twitter.');
      }

      const payload = {
        status,
        filePath
      };

      const url = window.location.protocol.toLowerCase().startsWith('https')
      ? `https://${window.location.hostname}/socialmedia`
      : this.apiUrl;
      fetch(`${url}/api/twitter/tweet`, {
        method: 'post',
        headers: this.getHeader(),
        body: JSON.stringify(payload)
      })
        .then(response => response.json())
        .then(response => resolve(response))
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
}

/**
 * Sets local store as json object, or removes it if null.
 */
const setLocalStorageObject = (key, value) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.removeItem(key);
  }
};

/**
 * Gets local store json object.
 */
const getLocalStorageObject = key => {
  const value = localStorage.getItem(key);
  return value && JSON.parse(value);
};



// WEBPACK FOOTER //
// ./app/api/twitter.js